import Vue from 'vue'
import store from '../store'
import {
    ACCESS_TOKEN,
    USER_NAME,
    NAME,
    USER_ID,
    USER_COMPANY_NAME,
    USER_ROLES,
    MENU_ACTIVE
} from '../store/mutation-type'

export default function Initializer() {
    store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
    store.commit('SET_USER_NAME', Vue.ls.get(USER_NAME))
    store.commit('SET_NAME', Vue.ls.get(NAME))
    store.commit('SET_USER_ID', Vue.ls.get(USER_ID))
    store.commit('SET_COMPANY_NAME', Vue.ls.get(USER_COMPANY_NAME))
    store.commit('SET_ROLES', Vue.ls.get(USER_ROLES))
    store.commit('SET_ACTIVE', Vue.ls.get(MENU_ACTIVE))
}
